import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>
				English buddy. <br /> Multifunctional vk-bot for learning English
			</h1>
			<p className='project-popup__description '>
				We use VK every day, and I suffered from a lack of service that would help me
				to find a partner for English practice. Well, some such services exist, but
				generally, they're just about finding a random person without paying
				attention to such factors as a level of language skills or age. I fixed the
				problem and created the English Buddy bot. It solves the problem. Later I
				added more features to Buddy: for example, now it can send random quotes by
				categories, English slang with definitions & examples, translate messages,
				and even read text from pics via artificial intelligence for further
				translation.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>Node.js, Mongo.db, VK-API</span>
				</p>
			</div>
			<div className='project-popup__images '>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/english_buddy/main.webp',
						backupImage: './media/projects/english_buddy/main.jpg',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='english_buddy_bot' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/english_buddy/2.webp',
						backupImage: './media/projects/english_buddy/2.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='english_buddy_bot' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/english_buddy/3.webp',
						backupImage: './media/projects/english_buddy/3.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='english_buddy_bot' />}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<a
					href='https://vk.com/english_buddy'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Visit project
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
